import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

function CurrentName() {
  const { user } = useKindeAuth();

  return [user?.given_name, user?.family_name].filter(Boolean).join(" ");
}

export default CurrentName;
